module.exports = __webpack_public_path__ + "static/media/food3.c9edd772.jpg";